module.exports = __webpack_public_path__ + "img/cjchengji.fc5d353d.jpg";